import { hashString } from './hashString';
export const createUniqueCustomProperty = (block, propertyName) => {
    const hash = hashString('design-system' + block + propertyName);
    return `--${block}-${propertyName}-${hash}`;
};
export const createUniqueCustomProperties = (block, propertyNames) => {
    return propertyNames.reduce((accum, propertyName) => {
        accum[propertyName] = createUniqueCustomProperty(block, propertyName);
        return accum;
    }, {});
};
//# sourceMappingURL=createUniqueCustomProperty.js.map
// @zapier/design-system@6.27.0 (617a97f69)
